import Service from 'react-reservice';

import { AxiosResponse } from '@webtrader/core/request';

class ExportService extends Service {
  constructor() {
    super();
  }

  public checkForDownload = (response: AxiosResponse): void => {
    if ('content-disposition' in response.headers) {
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches !== null && matches[1]) {
          const fileName = matches[1].replace(/['"]/g, '');
          this.downloadHandler(response.data as Blob, fileName);
        }
      }
    }
  };

  /**
   * This is the save downloaded file utility function
   * @param blob The binary string content of the download response
   * @param fileName The intended file final name - defaulted to `download.csv`
   */
  private downloadHandler = (blob: Blob, fileName = 'download.csv'): void => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };
}

export const exportService = new ExportService();
